// Google Analytics 4 utilities

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}

// Initialize GA4
export const initGA = () => {
  const measurementId = import.meta.env.VITE_GA4_MEASUREMENT_ID;
  
  if (!measurementId) {
    console.warn('GA4 Measurement ID not found');
    return;
  }

  // Load gtag script
  const script1 = document.createElement('script');
  script1.async = true;
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script1);

  // Initialize dataLayer
  window.dataLayer = window.dataLayer || [];
  window.gtag = function() {
    window.dataLayer.push(arguments);
  };
  
  window.gtag('js', new Date());
  window.gtag('config', measurementId, {
    send_page_view: false, // We'll handle page views manually
  });
};

// Track page views
export const trackPageView = (path: string, title?: string) => {
  const measurementId = import.meta.env.VITE_GA4_MEASUREMENT_ID;
  
  if (!measurementId || !window.gtag) return;
  
  window.gtag('config', measurementId, {
    page_path: path,
    page_title: title || document.title,
  });
};

// Track custom events
export const trackEvent = (
  eventName: string,
  parameters?: Record<string, any>
) => {
  if (!window.gtag) return;
  
  window.gtag('event', eventName, parameters);
};

// Conversion tracking helpers
export const trackConversion = {
  // Track special order submission
  specialOrder: (orderId?: string) => {
    trackEvent('generate_lead', {
      event_category: 'conversion',
      event_label: 'Special Order',
      value: 1,
      order_id: orderId,
    });
  },

  // Track job application submission
  jobApplication: (role?: string) => {
    trackEvent('generate_lead', {
      event_category: 'conversion',
      event_label: 'Job Application',
      value: 1,
      role: role,
    });
  },

  // Track contact form submission
  contactForm: () => {
    trackEvent('contact', {
      event_category: 'engagement',
      event_label: 'Contact Form',
    });
  },

  // Track filter view
  filterView: (filterId: string, filterName: string) => {
    trackEvent('view_item', {
      event_category: 'engagement',
      event_label: 'Filter View',
      filter_id: filterId,
      filter_name: filterName,
    });
  },

  // Track CTA button clicks
  ctaClick: (buttonName: string, location: string) => {
    trackEvent('click', {
      event_category: 'engagement',
      event_label: 'CTA Click',
      button_name: buttonName,
      location: location,
    });
  },

  // Track social media clicks
  socialClick: (platform: string) => {
    trackEvent('social_click', {
      event_category: 'engagement',
      event_label: 'Social Media',
      platform: platform,
    });
  },
};
